import { inject, Injectable } from "@angular/core";
import {
	GetAssetGenericGQLService,
	GetAssetGenericQuery,
	GetAssetGenericQueryVariables
} from "app/api/graphql/bff/generated/get-asset-generic.service.graphql-gen";
import { catchError, map, Observable } from "rxjs";
import { ExceptionsService } from "./exceptions.service";

export type BFFAsset = NonNullable<GetAssetGenericQuery["asset"]>;

@Injectable({
	providedIn: "root"
})
export class BFFAssetsService {
	private getAssetGenericGQLService = inject(GetAssetGenericGQLService);
	private exceptionsService = inject(ExceptionsService);

	getAssetFetch(input: GetAssetGenericQueryVariables): Observable<BFFAsset> {
		return this.getAssetGenericGQLService.fetch(input, { fetchPolicy: "cache-first" }).pipe(
			map(({ data: { asset } }) => {
				return asset as BFFAsset;
			}),
			catchError(this.exceptionsService.extractGqlErrorAndRethrow)
		);
	}
}
